var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Icon } from "../../UI";
import SidePanel from "../../Layout/SidePanel";
import { Translate } from "../../I18N";

import { closePanel } from "../actions/uiActions";
import { setRelationType, setTargetDocument } from "../actions/actions";
import ActionButton from "./ActionButton";
import SearchForm from "./SearchForm";
import SearchResults from "./SearchResults";

class CreateConnectionPanel extends Component {
  renderCheckType(template) {
    if (this.props.connection.get('template') === template.get('_id')) {
      return /*#__PURE__*/_jsx(Icon, { icon: "check" });
    }

    return /*#__PURE__*/_jsx(Icon, { icon: ['far', 'square'] });
  }

  render() {
    const { uiState, searchResults } = this.props;
    const connection = this.props.connection.toJS();
    const open = Boolean(
      this.props.uiState.get('open') && this.props.containerId === connection.sourceDocument
    );
    const className = `${this.props.className} create-reference`;

    return /*#__PURE__*/(
      _jsx(SidePanel, { open: open, className: className }, void 0, /*#__PURE__*/
      _jsx("div", { className: "sidepanel-header" }, void 0, /*#__PURE__*/
      _jsx("h1", {}, void 0,
      connection.type === 'basic' && /*#__PURE__*/_jsx(Translate, {}, void 0, "Create Connection"),
      connection.type !== 'basic' && /*#__PURE__*/_jsx(Translate, {}, void 0, "Create Reference")
      ), /*#__PURE__*/
      _jsx("button", {
        className: "closeSidepanel close-modal",
        onClick: this.props.closePanel,
        "aria-label": "Close side panel",
        type: "button" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "times" })
      ), /*#__PURE__*/
      _jsx("div", { className: "connections-list-title" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Select relationship type")
      ), /*#__PURE__*/
      _jsx("ul", { className: "connections-list multiselect" }, void 0,
      this.props.relationTypes.map((template) => /*#__PURE__*/
      _jsx("li", {
        onClick: () => this.props.setRelationType(template.get('_id')),

        className: "multiselectItem" }, template.get('_id'), /*#__PURE__*/

      _jsx("label", { className: "multiselectItem-label", htmlFor: template.get('_id') }, void 0, /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-icon" }, void 0, this.renderCheckType(template)), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-name" }, void 0, template.get('name'))
      )
      )
      )
      )
      ), /*#__PURE__*/

      _jsx("div", { className: "sidepanel-footer" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "btn-cluster content-right" }, void 0, /*#__PURE__*/
      _jsx("button", {
        className: "btn btn-default",
        onClick: this.props.closePanel,
        "aria-label": "Close side panel",
        type: "button" }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Cancel")
      ),
      connection.type !== 'targetRanged' && /*#__PURE__*/
      _jsx(ActionButton, {
        action: "save",
        onCreate: (reference) => {
          this.props.onCreate(reference);
        } }
      ),

      connection.type === 'targetRanged' && /*#__PURE__*/
      _jsx(ActionButton, { action: "connect", onRangedConnect: this.props.onRangedConnect })

      )
      ), /*#__PURE__*/

      _jsx("div", { className: "sidepanel-body" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "search-box" }, void 0, /*#__PURE__*/
      _jsx(SearchForm, { connectionType: connection.type })
      ), /*#__PURE__*/
      _jsx(SearchResults, {
        results: searchResults,
        searching: uiState.get('searching'),
        selected: connection.targetDocument,
        onClick: this.props.setTargetDocument }
      )
      )
      ));

  }
}















const mapStateToProps = ({ connections, relationTypes }) => ({
  uiState: connections.uiState,
  connection: connections.connection,
  searchResults: connections.searchResults,
  relationTypes
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setRelationType, setTargetDocument, closePanel }, dispatch);
}

export { CreateConnectionPanel, mapStateToProps };

export default connect(mapStateToProps, mapDispatchToProps)(CreateConnectionPanel);